import React, { Component } from 'react';
import '../../../lib/ueditor/ueditor.config.js';
import '../../../lib/ueditor/ueditor.all.min.js';
import '../../../lib/ueditor/lang/zh-cn/zh-cn.js';

class Ueditor extends Component {
  state = {}

  componentDidMount() {
    this.initEditor();
  }

  componentWillUnmount() {
    // 组件卸载后，清除放入库的id
    UE.delEditor(this.props.id);
  }

  initEditor = () => {
    const { id, uContent, initialFrameHeight, initialFrameWidth } = this.props;
    const ueEditor = UE.getEditor(id, { initialFrameHeight, initialFrameWidth });
    ueEditor.ready((ueditor) => {
      if (!ueditor) {
        UE.delEditor(id);
        this.initEditor();
      } else {
        ueEditor.setContent(uContent);
        if (id == "uContent") {
          ueEditor.addListener("selectionchange", function () {
            var arr = (UE.getEditor('uContent').getContentTxt());
            this.props.uContentChange(arr.substring(0, 30));
          })
        }
      }
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.uContent !== this.props.uContent) {
      this.initEditor();//抖动问题
    }
  }

  render() {
    return (
      <div id={this.props.id} name="content" type="text/plain"></div>
    )
  }
}

export default Ueditor;


// WEBPACK FOOTER //
// ./src/common/Ueditor/Ueditor.js